import { Injectable } from "@angular/core";
import { EncryptStorageEvent, FilesEndPoints, FilesModel, OrganizationModel } from "../..";
import { Events } from "ionic-angular";
import { FilesConverter } from "../../utils/converter/files-converter";
var FilesProvider = /** @class */ (function () {
    function FilesProvider(filesEndPoints, _events, _model, _orgModel) {
        this.filesEndPoints = filesEndPoints;
        this._events = _events;
        this._model = _model;
        this._orgModel = _orgModel;
        this._ready = false;
        this.bind();
    }
    FilesProvider.prototype.bind = function () {
        var _this = this;
        this._events.subscribe(EncryptStorageEvent.SECRET_PASSPHRASE_CHANGED, function (res) {
            _this._model.clear(false, true);
            if (res)
                _this._model.loadEncryptData();
        });
        this._events.subscribe(this._model.event.LOADED, function () {
            _this._ready = true;
            _this._events.publish(FilesProviderEvent.READY, _this._ready);
        });
    };
    Object.defineProperty(FilesProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilesProvider.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    FilesProvider.prototype.upload = function (files, onProgress, onFail, onLoadEnd, withToast) {
        var _this = this;
        return this.filesEndPoints.upload(this._orgModel.uri, files, onProgress, onFail, function (values) {
            var results = FilesConverter.convertFromFilesApiResultDataToFilesVoData(values);
            _this._model.addAll(results);
            onLoadEnd(results);
        }, withToast);
    };
    FilesProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    FilesProvider.ctorParameters = function () { return [
        { type: FilesEndPoints, },
        { type: Events, },
        { type: FilesModel, },
        { type: OrganizationModel, },
    ]; };
    return FilesProvider;
}());
export { FilesProvider };
export var FilesProviderEvent;
(function (FilesProviderEvent) {
    FilesProviderEvent["READY"] = "files-provider:ready";
})(FilesProviderEvent || (FilesProviderEvent = {}));
//# sourceMappingURL=files-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/files/files-provider.js
// module id = 381
// module chunks = 14